var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.convertVisible)?_c('div',{ref:"convertWrapperRef",class:{
    'message-convert': true,
    'reverse': _vm.props.message.flow === 'out',
    'error': _vm.hasConvertError,
  }},[_c('ConvertContent',{attrs:{"message":_vm.props.message,"contentVisible":_vm.convertVisible,"isSingleConvert":_vm.isSingleConvert,"convertWrapperRef":_vm.convertWrapperRef},on:{"toggleErrorStatus":_vm.toggleErrorStatus}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }